
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/orcamento/[...slug]",
      function () {
        return require("private-next-pages/orcamento/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/orcamento/[...slug]"])
      });
    }
  